import { render, staticRenderFns } from "./account-settings.vue?vue&type=template&id=12cfde76&scoped=true&"
import script from "./account-settings.vue?vue&type=script&lang=js&"
export * from "./account-settings.vue?vue&type=script&lang=js&"
import style0 from "./account-settings.vue?vue&type=style&index=0&id=12cfde76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfde76",
  null
  
)

export default component.exports